import { render, staticRenderFns } from "./ProgressTag.vue?vue&type=template&id=33944d78"
import script from "./ProgressTag.vue?vue&type=script&lang=js"
export * from "./ProgressTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports